import type { IAuthor, INavItem, ISiteNavigation } from '@anywayseo/tools';
import { StaticImage } from 'gatsby-plugin-image';

export const author: IAuthor = {
  name: 'Walker Pinyan',
  role: 'Game Expert',
  bio: "My name is Walker Pinyan and I am an expert author at casino-plinko.com. My work is related to analyzing and reviewing modern crash games like Plinko. I try to help users understand game mechanics, choose reliable platforms and learn strategies for a better gaming experience. I've been passionate about the gambling industry since 2018 and strive to make it more transparent and understandable for every player. My goal is to help you enjoy an exciting gaming experience and find the best offers on the market.",
  avatar: (
    <StaticImage src={'./assets/authors/walker-pinyan.jpg'} alt='Walker Pinyan' style={{ borderRadius: '50%' }} />
  ),
};

const plinkoGameRoutes: INavItem[] = [
  { slug: 'plinko-bgaming', label: 'Plinko BGaming' },
  { slug: 'plinko-xy', label: 'Plinko XY' },
];

export const localNavigation: ISiteNavigation = {
  header: {
    en: [{ slug: '', label: 'Plinko Games', children: plinkoGameRoutes }],
  },
  footer: {
    en: [
      { slug: 'privacy-policy', label: 'Privacy Policy' },
      { slug: 'cookie-policy', label: 'Cookie Policy' },
      { slug: 'terms-and-conditions', label: 'Terms & Conditions' },
      { slug: 'contacts', label: 'Contacts' },
    ],
  },
};
